import HelpIcon from '@mui/icons-material/Help';
import Tooltip from '@mui/material/Tooltip';
import { CSSProperties, ReactElement, ReactNode, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
interface Props {
    text?: string | ReactElement;
    style?: CSSProperties;
    placement?: 'top' | 'bottom' | 'top-start' | 'left';
    children?: ReactNode;
    background?: 'redTooltips';
    disabled?: boolean;
}

const QuestionWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.2rem;
    border: none;
    background: none;
    outline: none;
    cursor: default;
    border-radius: 36px;
    color: #9d9d9d;
    :hover,
    :focus {
        opacity: 0.7;
    }

    svg {
        width: 16px;
        height: 16px;
        cursor: pointer;
        color: #ccc;
    }
`;

const GStyle = createGlobalStyle`
    #redTooltips {
        z-index: 1;
        > .MuiTooltip-tooltip {
            padding: 12px;
            font-size: 12px;;
            background: red;
            max-width: unset;
            .MuiTooltip-arrow  {
                color: red;
            }
        }
    }
`;

const TooltipsWrapper = styled(Tooltip)``;

export default function TooltipInfo({
    text = '',
    style: cssStyle,
    placement = 'top',
    children,
    background,
    disabled = false,
}: Props) {
    const [open, setOpen] = useState<boolean>(false);

    const show = () => {
        setOpen(true);
    };

    const hide = () => {
        setOpen(false);
    };
    const id = background;

    if (disabled) return children;

    return (
        <TooltipsWrapper
            title={text}
            placement={placement}
            arrow
            onMouseEnter={() => show()}
            onClick={() => show()}
            onMouseLeave={() => hide()}
            open={open || false}
            id={id}
        >
            {children ? (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        ...cssStyle,
                    }}
                >
                    {children}
                    <GStyle />
                </div>
            ) : (
                <QuestionWrapper
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        ...cssStyle,
                    }}
                >
                    <HelpIcon />
                </QuestionWrapper>
            )}
        </TooltipsWrapper>
    );
}
